// @ts-strict-ignore
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Typography, Spacer } from "@aviary";
import { OAuthLandingTiles } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthLandingStep/OAuthLandingTiles/OAuthLandingTiles";
import { l } from "@unauthenticated/oauth/locales/i18n";

import { OAuthStep } from "../../oauthStep";

import * as styles from "./OAuthLandingPage.styles";

interface Props {
  onUpdateCurrentStep: (step: OAuthStep) => void;
}

const OAuthLandingPage = ({ onUpdateCurrentStep }: Props) => {
  const { t } = useTranslation();
  const [isCheckedSignIn, setIsCheckedSignIn] = useState(null);

  const handleContinue = () =>
    onUpdateCurrentStep(isCheckedSignIn ? OAuthStep.SIGN_IN : OAuthStep.SIGN_UP);

  return (
    <div css={styles.body}>
      <Typography type="h2">{t(l.oauth.AreYouNew)}</Typography>
      <Typography>{t(l.oauth.PickOneOf)}</Typography>
      <Spacer height="quad" />
      <OAuthLandingTiles
        isCheckedSignIn={isCheckedSignIn}
        setIsCheckedSignIn={setIsCheckedSignIn}
      />
      <Button
        intention="primary"
        css={styles.button}
        disabled={isCheckedSignIn === null}
        onClick={handleContinue}
      >
        {t(l.oauth.ContinueButton)}
      </Button>
    </div>
  );
};

export { OAuthLandingPage };
